import React, {useEffect, useRef, useState} from 'react';
import {assistantPlaceholderIc} from '../../../../assets/images';
import {aiAssistantText} from '../aiAssistantText';
import Switch from '../../../../uiToolkit/Inputs/Switch';
import AiAssistantOptions from './AiAssistantOptions';
import {AiAssistantListItem} from '../../../../data/models/AI/AiAssistantModels';
import Tooltip from '../../../../uiToolkit/Tooltip';

interface Props {
  onPreviewAssistant: (id: string) => void;
  assistant: AiAssistantListItem;
  toggleAiAssitantVisibility: (
    assistantId: string,
    isCurrentlyVisible: boolean,
  ) => void;
  visibilityLoading: boolean;
  onDeleteAssistant: (id: string) => void;
  onEditAssistant: (id: string) => void;
  onShareAssistant: (assistantId: string, assistantTitle: string) => void;
  onRefresh: () => void;
}

const AiAssistantCard = React.memo(
  ({
    onPreviewAssistant,
    assistant,
    toggleAiAssitantVisibility,
    visibilityLoading,
    onDeleteAssistant,
    onEditAssistant,
    onShareAssistant,
    onRefresh,
  }: Props) => {
    const [showAssigned, setShowAssigned] = useState(false);
    const [enabled, setEnabled] = useState(false);

    const openerRef = useRef<any>(null);
    const openerTextRef = useRef<any>(null);
    const openerArrowRef = useRef<any>(null);

    useEffect(() => {
      setEnabled(assistant.enabled);
    }, [assistant]);

    const onToggleEnabled = (value: boolean) => {
      toggleAiAssitantVisibility(assistant.id, assistant.enabled);
      setEnabled(value);
    };

    useEffect(() => {
      window.addEventListener('click', handleBodyClick);
      return () => {
        window.removeEventListener('click', handleBodyClick);
      };
    }, [showAssigned]);

    const handleBodyClick = (ev: any) => {
      if (
        showAssigned &&
        openerRef?.current !== ev.target &&
        openerTextRef?.current !== ev.target &&
        openerArrowRef?.current !== ev.target
      ) {
        setShowAssigned(false);
      }
    };

    return (
      <div className="AssistantCardContainer">
        <div className="AssistantCard">
          <div className="ImageContainer">
            {assistant.avatarUrl ? (
              <img src={assistant.avatarUrl} />
            ) : (
              <img src={assistantPlaceholderIc} className="PlaceholderLogo" />
            )}
          </div>
          <div className="CardBody">
            <div className="InfoContainer">
              <Tooltip tooltipText={assistant.title}>
                <p>{assistant.title}</p>
              </Tooltip>
              <span className="Description">
                {assistant.status === 0
                  ? assistant.description
                  : assistant.isNew
                  ? aiAssistantText.assistantIsProcessingCreate
                  : aiAssistantText.assistantIsProcessingUpdate}
              </span>
            </div>
            {assistant.status === 0 ? (
              <div className="Footer">
                <div
                  ref={openerRef}
                  onClick={() => setShowAssigned(!showAssigned)}
                  className={`AssignedOpener ${
                    showAssigned ? 'AssignedOpenerOpen' : ''
                  }`}>
                  <span ref={openerArrowRef}>{aiAssistantText.assigned}</span>
                  <span className="icon-chevron-up" ref={openerTextRef}></span>
                </div>
                <Switch
                  value={enabled}
                  disabled={visibilityLoading}
                  onToggle={() => onToggleEnabled(!enabled)}
                />
              </div>
            ) : null}
          </div>
        </div>
        {showAssigned && (
          <div className="AssignmentsPopup">
            {assistant.assignedCourses.map(course => (
              <p key={course}>{course}</p>
            ))}
          </div>
        )}
        <div className="AssistantOptionsPosition">
          {assistant.status === 0 ? (
            <AiAssistantOptions
              onPreviewAssistant={onPreviewAssistant}
              onDeleteAssistant={onDeleteAssistant}
              assistant={assistant}
              onEditAssistant={onEditAssistant}
              onShareAssistant={onShareAssistant}
            />
          ) : (
            <button className="RefreshFileStatus" onClick={onRefresh}>
              <span className="icon-typeReload"></span>
            </button>
          )}
        </div>
      </div>
    );
  },
);

export default AiAssistantCard;
